import { h } from 'preact'
import { useState } from 'preact/hooks'
import { connect } from 'unistore/preact'
import { Row } from 'jsxstyle/preact'
import { goBack, Route, routeTo } from '@sodra/prutt'
import {
  AddIcon,
  FileInput,
  NativeSelect,
  SelectButton,
  SelectChip,
  SpacerVertical
} from '@sodra/bongo-ui'

import { accentOptions, ageSoundsLikeOptions, genderSoundsLikeOptions } from '../options'
import { showSnackbar, uploadAudio } from '../../actions'

import LargeDialog from '../LargeDialog'

import SelectType from './SelectType'
import SelectTone from './SelectTone'
import { getName, SelectLanguage } from '../SelectLanguage'
import ErrorMessage from '../ErrorMessage'

const UploadAudio = ({ user, isUploadingAudio }) => {
  const [file, setFile] = useState()
  const [language, setLanguage] = useState('English')
  const [accent, setAccent] = useState()
  const [soundsLike, setSoundsLike] = useState()
  const [gender, setGender] = useState(user.gender)
  const [types, setTypes] = useState([])
  const [tones, setTones] = useState([])
  const [showSelectLanguage, setShowSelectLanguage] = useState(false)

  const [fileError, setFileError] = useState()
  const [languageError, setLanguageError] = useState()
  const [typeError, setTypeError] = useState()

  const addType = (type) => {
    setTypes((types) => (types.includes(type) ? types : [...types, type]))
  }

  const removeType = (type) => {
    setTypes((types) => types.filter((t) => t !== type))
  }

  const addTone = (tone) => {
    setTones((tones) => (tones.includes(tone) ? tones : [...tones, tone]))
  }

  const removeTone = (tone) => {
    setTones((tones) => tones.filter((t) => t !== tone))
  }

  const onClose = () => goBack(`/user/${user.id}`)
  const closeDialog = () => goBack(`/user/${user.id}/upload-audio`)

  const handleUpload = async () => {
    let error = false

    if (!file) {
      setFileError('Please select an audio file')
      error = true
    } else {
      setFileError()
    }

    if (!language) {
      setLanguageError('Please select a language')
      error = true
    } else {
      setLanguageError()
    }

    if (!types || types.length === 0) {
      setTypeError('Please select a type')
      error = true
    } else {
      setTypeError()
    }

    if (error) {
      return
    }

    if (await uploadAudio(file, { language, accent, soundsLike, types, tones, gender })) {
      showSnackbar('Audio sampe uploaded')
      onClose()
    }
  }

  return (
    <LargeDialog
      title="Upload voice demo"
      actions={[
        { text: 'Upload', type: 'contained', loading: isUploadingAudio, onClick: handleUpload },
        { text: 'Cancel', onClick: onClose }
      ]}
      onClose={onClose}
    >
      <SpacerVertical />
      <FileInput
        width="100%"
        label="Audio file"
        accept="audio/*"
        value={file}
        onChange={setFile}
        errorText={fileError}
      />
      <SpacerVertical />
      <SelectButton
        width="100%"
        label="Language"
        selected={language ? { text: language } : undefined}
        onClick={() => setShowSelectLanguage(true)}
      />
      {languageError && <ErrorMessage>{languageError}</ErrorMessage>}
      <SpacerVertical />
      <NativeSelect
        width="100%"
        label="Accent (optional)"
        options={accentOptions}
        value={accent}
        onChange={setAccent}
      />
      <SpacerVertical />
      <NativeSelect
        width="100%"
        label="Age – Sounds like (optional)"
        options={ageSoundsLikeOptions}
        value={soundsLike}
        onChange={setSoundsLike}
      />
      <SpacerVertical />
      <NativeSelect
        width="100%"
        label="Gender – Sounds like"
        options={genderSoundsLikeOptions}
        value={gender}
        onChange={setGender}
      />
      <SpacerVertical />
      <Row alignItems="center" flexWrap="wrap">
        {types.map((type) => {
          return (
            <SelectChip
              marginRight="5px"
              marginBottom="5px"
              value={type}
              onClear={() => removeType(type)}
            />
          )
        })}
        {types.length < 3 && (
          <SelectChip
            label="Type"
            icon={AddIcon}
            onClick={() => routeTo(`/user/${user.id}/upload-audio/select-type`)}
          />
        )}
      </Row>
      {typeError && <ErrorMessage padding="5px 15px 0 15px">{typeError}</ErrorMessage>}
      <SpacerVertical />
      <Row alignItems="center" flexWrap="wrap">
        {tones.map((tone) => {
          return (
            <SelectChip
              marginRight="5px"
              marginBottom="5px"
              value={tone}
              onClear={() => removeTone(tone)}
            />
          )
        })}
        {tones.length < 10 && (
          <SelectChip
            label="Tone (optional)"
            icon={AddIcon}
            onClick={() => routeTo(`/user/${user.id}/upload-audio/select-tone`)}
          />
        )}
      </Row>
      {showSelectLanguage && (
        <SelectLanguage
          onClose={() => {
            setShowSelectLanguage(false)
          }}
          onSelect={(language) => {
            setLanguage(getName(language))
          }}
        />
      )}
      <Route
        path="/user/:userId/upload-audio/select-type"
        render={() => <SelectType onSelect={addType} onClose={closeDialog} />}
      />
      <Route
        path="/user/:userId/upload-audio/select-tone"
        render={() => <SelectTone onSelect={addTone} onClose={closeDialog} />}
      />
    </LargeDialog>
  )
}

export default connect('user, isUploadingAudio')(UploadAudio)
